export enum GuideTypesEnum {
  TWO_COLS = "Two columns",
  THREE_COLS = "Three columns",
  SHOPPING_CART = "Shopping cart",
}
